export default __webpack_public_path__ + "static/media/e-statement.cce39f35.png";